"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _TMRDWUTBcjs = require('../__chunks/TMRDWUTB.cjs');



var _7DAL4U2Wcjs = require('../__chunks/7DAL4U2W.cjs');
require('../__chunks/MLKK6UGO.cjs');


var _6E4BBKC4cjs = require('../__chunks/6E4BBKC4.cjs');
require('../__chunks/2XVCJUVB.cjs');
require('../__chunks/MMSR5JSJ.cjs');
require('../__chunks/UCZW3OGH.cjs');
require('../__chunks/MWXEIKZX.cjs');
require('../__chunks/T3QB4FR3.cjs');


var _FH6HQ5JNcjs = require('../__chunks/FH6HQ5JN.cjs');
require('../__chunks/XWMMMXUK.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');


var _3BSDKDKDcjs = require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/toolbar/toolbar.tsx
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var useToolbar = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useToolbar2({
    store: storeProp,
    orientation: orientationProp,
    virtualFocus,
    focusLoop,
    rtl,
    ...props
  }) {
    const context = _7DAL4U2Wcjs.useToolbarProviderContext.call(void 0, );
    storeProp = storeProp || context;
    const store = _TMRDWUTBcjs.useToolbarStore.call(void 0, {
      store: storeProp,
      orientation: orientationProp,
      virtualFocus,
      focusLoop,
      rtl
    });
    const orientation = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => state.orientation === "both" ? void 0 : state.orientation
    );
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _7DAL4U2Wcjs.ToolbarScopedContextProvider, { value: store, children: element }),
      [store]
    );
    props = {
      role: "toolbar",
      "aria-orientation": orientation,
      ...props
    };
    props = _6E4BBKC4cjs.useComposite.call(void 0, { store, ...props });
    return props;
  }
);
var Toolbar = _PTOCUU2Dcjs.forwardRef.call(void 0, function Toolbar2(props) {
  const htmlProps = useToolbar(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.Toolbar = Toolbar; exports.useToolbar = useToolbar;
